// extracted by mini-css-extract-plugin
export default {"form":"payment-details-fixed__form___gQOpt","stripeIconWrapper":"payment-details-fixed__stripeIconWrapper___tBXMV","payButton":"payment-details-fixed__payButton___HUVYo"};